import { config } from 'zod';

// Zod probes `new Function('')` once to decide whether to JIT-compile object
// parsers. The app origin's CSP has no `'unsafe-eval'`, so the probe fails and
// Zod falls back to its interpreter anyway; it still files a CSP violation on
// every page load. `jitless` skips the probe and keeps the CSP reports to real
// violations (#4771). Imported from `main.tsx` before anything parses.
config({ jitless: true });
